class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

const MegaMenuScrollLockStickyNone = {
  scrollY: 0,

  isStickyNone() {
    return !document.querySelector("sticky-header");
  },

  init() {
    document.querySelectorAll(".mega-menu").forEach((menu) => {
      if (menu.dataset.stickyNoneScrollLockBound) return;
      menu.dataset.stickyNoneScrollLockBound = "true";
      menu.addEventListener("toggle", () => this.sync());
    });
  },

  sync() {
    if (!this.isStickyNone()) return;

    const hasOpenMenu = !!document.querySelector(".mega-menu[open]");

    if (hasOpenMenu) {
      if (
        !document.body.classList.contains("mega-menu-scroll-locked--sticky-none")
      ) {
        this.lock();
      }
    } else if (
      document.body.classList.contains("mega-menu-scroll-locked--sticky-none")
    ) {
      this.unlock();
    }
  },

  lock() {
    this.scrollY = window.scrollY;
    document.documentElement.style.setProperty(
      "--mega-menu-scroll-lock-top",
      `-${this.scrollY}px`,
    );
    document.documentElement.classList.add(
      "mega-menu-scroll-locked--sticky-none",
    );
    document.body.classList.add("mega-menu-scroll-locked--sticky-none");
  },

  unlock() {
    document.documentElement.classList.remove(
      "mega-menu-scroll-locked--sticky-none",
    );
    document.body.classList.remove("mega-menu-scroll-locked--sticky-none");
    document.documentElement.style.removeProperty(
      "--mega-menu-scroll-lock-top",
    );
    window.scrollTo(0, this.scrollY);
  },
};

window.MegaMenuScrollLockStickyNone = MegaMenuScrollLockStickyNone;

function initMegaMenuScrollLockStickyNone() {
  MegaMenuScrollLockStickyNone.init();
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    initMegaMenuScrollLockStickyNone,
  );
} else {
  initMegaMenuScrollLockStickyNone();
}

document.addEventListener(
  "shopify:section:load",
  initMegaMenuScrollLockStickyNone,
);

const MegaMenuOnScrollUp = {
  isOnScrollUp() {
    return !!document.querySelector(
      'sticky-header[data-sticky-type="on-scroll-up"]',
    );
  },

  isAtPageTop() {
    return (window.pageYOffset || document.documentElement.scrollTop) <= 0;
  },

  updateOverlayTop() {
    const headerBar = document.querySelector(".header-wrapper > .header");
    const sectionHeader = document.querySelector(".section-header");
    let top = 0;

    if (headerBar) {
      top = Math.max(0, Math.round(headerBar.getBoundingClientRect().bottom));
    } else if (sectionHeader) {
      top = Math.max(0, Math.round(sectionHeader.getBoundingClientRect().bottom));
    }

    document.documentElement.style.setProperty(
      "--mega-menu-overlay-top",
      `${top}px`,
    );
  },

  init() {
    document.querySelectorAll(".mega-menu").forEach((menu) => {
      if (menu.dataset.onScrollUpOverlayBound) return;
      menu.dataset.onScrollUpOverlayBound = "true";
      menu.addEventListener("toggle", () => this.sync());
    });

    if (!this.boundResize) {
      this.boundResize = () => {
        if (this.isOnScrollUp() && document.querySelector(".mega-menu[open]")) {
          this.updateOverlayTop();
        }
      };
      window.addEventListener("resize", this.boundResize);
    }
  },

  sync() {
    if (!this.isOnScrollUp()) return;

    const sectionHeader = document.querySelector(".section-header");
    const hasOpenMega = !!document.querySelector(".mega-menu[open]");

    if (!sectionHeader) return;

    if (hasOpenMega) {
      sectionHeader.classList.add("shopify-section-header-sticky", "menu-open");
      this.updateOverlayTop();
      requestAnimationFrame(() => this.updateOverlayTop());
    } else {
      sectionHeader.classList.remove("menu-open");
      document.documentElement.style.removeProperty("--mega-menu-overlay-top");

      if (this.isAtPageTop()) {
        sectionHeader.classList.remove(
          "shopify-section-header-sticky",
          "animate",
          "scrolled-past-header",
        );
      }
    }
  },
};

window.MegaMenuOnScrollUp = MegaMenuOnScrollUp;

function initMegaMenuOnScrollUp() {
  MegaMenuOnScrollUp.init();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMegaMenuOnScrollUp);
} else {
  initMegaMenuOnScrollUp();
}

document.addEventListener("shopify:section:load", initMegaMenuOnScrollUp);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  onToggle() {
    if (!this.header) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    MegaMenuScrollLockStickyNone.sync();
    MegaMenuOnScrollUp.sync();

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }

  close() {
    super.close();
    MegaMenuScrollLockStickyNone.sync();
    MegaMenuOnScrollUp.sync();
  }
}

customElements.define("header-menu", HeaderMenu);
